var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border border-bottom border-secondary bg-white",attrs:{"id":"header"}},[_c('dicta-header',{attrs:{"hebrew-supported":true,"english-supported":!_vm.disableEnglishUI}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }